export class position_create 
{
    public size=995;
    public pick_array=new Array();
    public per=0.8;
    public constructor() 
    {
        
    }


    
    public all_position(spritsArray:BABYLON.AbstractMesh[],scene:BABYLON.Scene,ca_p:BABYLON.Vector3): Array< BABYLON.Vector3>
    {
        this.set_pickable(scene);
        let array_p=new Array();
        let arr=spritsArray;
        
        if(arr.length>0)
        {
            for(let i=0;i<arr.length;i++)
            {
                if(arr[i]!=null)
                {
                    let ar=this.single_position1(arr[i],scene,ca_p);
                    for(let j=0;j<ar.length;j++)
                    {
                        array_p.push(ar[j]);
                    }
                }
                
            }
        }
        this.recover_pickable(scene);
        return array_p;
    }


    public single_position1(obj:Nullable<BABYLON.AbstractMesh>,scene:BABYLON.Scene,ca_p:BABYLON.Vector3): Array< BABYLON.Vector3>
    {
        let array_p=new Array();
        let p:BABYLON.Vector3=BABYLON.Vector3.Zero();
        
        if(obj!=null)
        {
           let ar=this.get_four_vertax(obj,ca_p);
           array_p=this.get_p(obj,scene,ca_p,ar);
        }
        else
        {
        }
        return array_p;
    }


    public single_position(name:string,scene:BABYLON.Scene,ca_p:BABYLON.Vector3): Array< BABYLON.Vector3>
    {
        let array_p=new Array();
        let p:BABYLON.Vector3=BABYLON.Vector3.Zero();
        this.set_pickable(scene);
        let obj=this.find_by_name(scene,name);
        if(obj!=null)
        {
           let ar=this.get_four_vertax(obj,ca_p);
           array_p=this.get_p(obj,scene,ca_p,ar);
        }
        else
        {
            console.log(name.toString()+" 该物体不存在");
        }
        this.recover_pickable(scene);
        return array_p;
    }

    get_p(obj:BABYLON.AbstractMesh,scene:BABYLON.Scene,center:BABYLON.Vector3,p_l:Array< BABYLON.Vector3>): Array< BABYLON.Vector3>
    {
        if(obj.parent!=null)
        {
        }
        let did_hit=false;

        for(let i=0;i<p_l.length;i++)
        {
            let l=BABYLON.Vector3.Distance(center,p_l[i]);
            var ray=new BABYLON.Ray(center,p_l[i].subtract(center),l);
            var hit=scene.pickWithRay(ray);
            if(hit?.pickedMesh)
            {
                if((hit.distance+1)<l)
                {

                    if(hit.pickedMesh.name!=obj.name)
                    {
                        console.log("center is"+center);
                        console.log(hit.distance+" "+l);
                        console.log("hit"+hit.pickedMesh.name+" before "+obj.name);
                        did_hit=true;
                        break;
                    }
                   
                }
            }
            else
            {
                console.log("wow");
            }
        }
        if(did_hit)
        {
            let result=new Array();
            result.push(new BABYLON.Vector3(-1000,-1000,-1000));
            result.push(new BABYLON.Vector3(-1000,-1000,-1000));
            result.push(new BABYLON.Vector3(-1000,-1000,-1000));
            result.push(new BABYLON.Vector3(-1000,-1000,-1000));
            return result;
        }


        let ar=this.get_four_vertax1(obj,center);


        for(let i=0;i<ar.length;i++)
        {
            ar[i]=ar[i].subtract(center);
        }

        
        let result=new Array();
        for(let i=0;i<p_l.length;i++)
        {
            let p=new BABYLON.Vector3(-ar[i].z,ar[i].y,ar[i].x);
            p.normalize();
            p=p.scale(this.size/2);

           result.push(p);
        }
        return result;
    }

    set_pickable(scene:BABYLON.Scene)
    {
        this.pick_array.length=0;
        for(let i=0;i<scene.meshes.length;i++)
        {
            this.pick_array.push(scene.meshes[i].isPickable);
            scene.meshes[i].isPickable=true;
        }
    }

    recover_pickable(scene:BABYLON.Scene)
    {
        for(let i=0;i<scene.meshes.length;i++)
        {
            
            scene.meshes[i].isPickable=this.pick_array[i];
        }
    }


    //通过名字查找单个物体
    public find_by_name(scene:BABYLON.Scene,name:string): Nullable<BABYLON.AbstractMesh>
    {
        return scene.getMeshByName(name);

    }
    //通过命名规则查找多个物体

    public find_by_names(scene:BABYLON.Scene,name:string): Array< Nullable<BABYLON.AbstractMesh>>
    {
        let mesh_array=new Array();
      
        let done=false;
        for(let i=1;i<10;i++)
        {
            let real_name=name+"_0"+i.toString();
            // console.log(real_name);
            let obj=scene.getMeshByName(real_name);
            if(obj==null)
            {
                console.log("done");
                done=true;
                break
            }
                
            else
                mesh_array.push(obj);
        }
        if(!done)
        for(let i=10;i<100;i++)
        {
            let real_name=name+"_"+i.toString();
            let obj=scene.getMeshByName(real_name);
            if(obj==null)
            {
                done=true;
                break;
            }
            else
                mesh_array.push(obj);
        }

        return mesh_array;
    }

    transform_point(corner:BABYLON.Vector3,col:BABYLON.AbstractMesh)
    {
       var transformMatrix1=col.computeWorldMatrix(true);;//= col.my_mesh._localMatrix;//.computeWorldMatrix();
       transformMatrix1=col.getWorldMatrix();
        return BABYLON.Vector3.TransformCoordinates(corner,transformMatrix1);
    }


    get_four_vertax(obj:BABYLON.AbstractMesh,ca_p:BABYLON.Vector3):Array< BABYLON.Vector3>
    {
        let ar=new Array();
        let p=obj.getVerticesData(BABYLON.VertexBuffer.PositionKind);
        if(p!=null)
        {
            let xmax=p[0]*this.per;
            let xmin=p[0]*this.per;
            let ymax=p[1]*this.per;
            let ymin=p[1]*this.per;
            let zmax=p[2]*this.per;
            let zmin=p[2]*this.per;

            for(let i=0;i<p.length/3;i++)
            {
                if(p[i*3]*this.per>xmax)
                    xmax=p[i*3]*this.per;
                if(p[i*3]*this.per<xmin)
                    xmin=p[i*3]*this.per;

                if(p[i*3+1]*this.per>ymax)
                    ymax=p[i*3+1]*this.per;
                if(p[i*3+1]*this.per<ymin)
                    ymin=p[i*3+1]*this.per;

                if(p[i*3+2]*this.per>zmax)
                    zmax=p[i*3+2]*this.per;
                if(p[i*3+2]*this.per<zmin)
                    zmin=p[i*3+2]*this.per;
            }

            let abs_x=xmax-xmin;
            let abs_y=ymax-ymin;
            let abs_z=zmax-zmin;


            let midx=(xmax+xmin)/2;
            let midy=(ymax+ymin)/2;
            let midz=(zmax+zmin)/2;


            if(abs_y<0.001)
            {
                let p1=new BABYLON.Vector3(xmax,ymin,zmin);
                let p2=new BABYLON.Vector3(xmax,ymin,zmax);
    
                let p3=new BABYLON.Vector3(xmin,ymax,zmin);
                let p4=new BABYLON.Vector3(xmin,ymax,zmax);

                let new_v1=this.transform_point(p1,obj);

                ar.push(new_v1);
                let new_v2=this.transform_point(p2,obj);

                ar.push(new_v2);
                let new_v3=this.transform_point(p3,obj);

                ar.push(new_v3);
                let new_v4=this.transform_point(p4,obj);

                ar.push(new_v4);
                return ar;
            }


            if(abs_x<0.001)
            {
                let p1=new BABYLON.Vector3(xmin,ymax,zmin);
                let p2=new BABYLON.Vector3(xmax,ymax,zmax);
    
                let p3=new BABYLON.Vector3(xmin,ymin,zmin);
                let p4=new BABYLON.Vector3(xmax,ymin,zmax);

                let new_v1=this.transform_point(p1,obj);

                ar.push(new_v1);
                let new_v2=this.transform_point(p2,obj);

                ar.push(new_v2);
                let new_v3=this.transform_point(p3,obj);

                ar.push(new_v3);
                let new_v4=this.transform_point(p4,obj);

                ar.push(new_v4);
                return ar;

            }
            if(abs_z<0.001)
            {
                let p1=new BABYLON.Vector3(xmax,ymin,zmin);
                let p2=new BABYLON.Vector3(xmax,ymax,zmin);
    
                let p3=new BABYLON.Vector3(xmin,ymin,zmax);
                let p4=new BABYLON.Vector3(xmin,ymax,zmax);

                let new_v1=this.transform_point(p1,obj);

                ar.push(new_v1);
                let new_v2=this.transform_point(p2,obj);

                ar.push(new_v2);
                let new_v3=this.transform_point(p3,obj);

                ar.push(new_v3);
                let new_v4=this.transform_point(p4,obj);

                ar.push(new_v4);
                return ar;
            }


            let l1=xmax-xmin;
            let l2=zmax-zmin;
            if(l1>l2)
            {
                let bot1=new BABYLON.Vector3(xmin,ymin,zmin);
                let bot2=new BABYLON.Vector3(xmin,ymin,zmax);

                let d1=BABYLON.Vector3.Distance(bot1,ca_p);
                let d2=BABYLON.Vector3.Distance(bot2,ca_p);
                if(d1>d2)
                {
                    let p1=new BABYLON.Vector3(xmin,ymin,zmax);
                    let p2=new BABYLON.Vector3(xmax,ymin,zmax);
        
                    let p3=new BABYLON.Vector3(xmax,ymax,zmax);
                    let p4=new BABYLON.Vector3(xmin,ymax,zmax);

                    let new_v1=this.transform_point(p1,obj);

                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
                else
                {
                    let p1=new BABYLON.Vector3(xmin,ymin,zmin);
                    let p2=new BABYLON.Vector3(xmax,ymin,zmin);
        
                    let p3=new BABYLON.Vector3(xmax,ymax,zmin);
                    let p4=new BABYLON.Vector3(xmin,ymax,zmin);

                    let new_v1=this.transform_point(p1,obj);

                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
            }
            else
            {
                let bot1=new BABYLON.Vector3(xmin,ymin,zmin);
                let bot2=new BABYLON.Vector3(xmax,ymin,zmin);

                let d1=BABYLON.Vector3.Distance(bot1,ca_p);
                let d2=BABYLON.Vector3.Distance(bot2,ca_p);
                if(d1>d2)
                {
                    let p1=new BABYLON.Vector3(xmax,ymin,zmin);
                    let p2=new BABYLON.Vector3(xmax,ymin,zmax);
        
                    let p3=new BABYLON.Vector3(xmax,ymax,zmax);
                    let p4=new BABYLON.Vector3(xmax,ymax,zmin);
    
                    let new_v1=this.transform_point(p1,obj);
    
                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
                else
                {
                    let p1=new BABYLON.Vector3(xmin,ymin,zmin);
                    let p2=new BABYLON.Vector3(xmin,ymin,zmax);
        
                    let p3=new BABYLON.Vector3(xmin,ymax,zmax);
                    let p4=new BABYLON.Vector3(xmin,ymax,zmin);
    
                    let new_v1=this.transform_point(p1,obj);
    
                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
            }
        }
        return ar;
    }


    get_four_vertax1(obj:BABYLON.AbstractMesh,ca_p:BABYLON.Vector3):Array< BABYLON.Vector3>
    {
        let ar=new Array();
        let p=obj.getVerticesData(BABYLON.VertexBuffer.PositionKind);
        if(p!=null)
        {
            let xmax=p[0];
            let xmin=p[0];
            let ymax=p[1];
            let ymin=p[1];
            let zmax=p[2];
            let zmin=p[2];

            for(let i=0;i<p.length/3;i++)
            {
                if(p[i*3]>xmax)
                    xmax=p[i*3];
                if(p[i*3]<xmin)
                    xmin=p[i*3];

                if(p[i*3+1]>ymax)
                    ymax=p[i*3+1];
                if(p[i*3+1]<ymin)
                    ymin=p[i*3+1];

                if(p[i*3+2]>zmax)
                    zmax=p[i*3+2];
                if(p[i*3+2]<zmin)
                    zmin=p[i*3+2];
            }

            let abs_x=xmax-xmin;
            let abs_y=ymax-ymin;
            let abs_z=zmax-zmin;


            let midx=(xmax+xmin)/2;
            let midy=(ymax+ymin)/2;
            let midz=(zmax+zmin)/2;

            if(abs_y<0.001)
            {
                let p1=new BABYLON.Vector3(xmax,ymin,zmin);
                let p2=new BABYLON.Vector3(xmax,ymin,zmax);
    
                let p3=new BABYLON.Vector3(xmin,ymax,zmin);
                let p4=new BABYLON.Vector3(xmin,ymax,zmax);

                let new_v1=this.transform_point(p1,obj);

                ar.push(new_v1);
                let new_v2=this.transform_point(p2,obj);

                ar.push(new_v2);
                let new_v3=this.transform_point(p3,obj);

                ar.push(new_v3);
                let new_v4=this.transform_point(p4,obj);

                ar.push(new_v4);
                return ar;
            }

            if(abs_x<0.001)
            {
                let p1=new BABYLON.Vector3(xmin,ymax,zmin);
                let p2=new BABYLON.Vector3(xmax,ymax,zmax);
    
                let p3=new BABYLON.Vector3(xmin,ymin,zmin);
                let p4=new BABYLON.Vector3(xmax,ymin,zmax);

                let new_v1=this.transform_point(p1,obj);

                ar.push(new_v1);
                let new_v2=this.transform_point(p2,obj);

                ar.push(new_v2);
                let new_v3=this.transform_point(p3,obj);

                ar.push(new_v3);
                let new_v4=this.transform_point(p4,obj);

                ar.push(new_v4);
                return ar;

            }
            if(abs_z<0.001)
            {
                let p1=new BABYLON.Vector3(xmax,ymin,zmin);
                let p2=new BABYLON.Vector3(xmax,ymax,zmin);
    
                let p3=new BABYLON.Vector3(xmin,ymin,zmax);
                let p4=new BABYLON.Vector3(xmin,ymax,zmax);

                let new_v1=this.transform_point(p1,obj);

                ar.push(new_v1);
                let new_v2=this.transform_point(p2,obj);

                ar.push(new_v2);
                let new_v3=this.transform_point(p3,obj);

                ar.push(new_v3);
                let new_v4=this.transform_point(p4,obj);

                ar.push(new_v4);
                return ar;
            }


            let l1=xmax-xmin;
            let l2=zmax-zmin;
            if(l1>l2)
            {
                let bot1=new BABYLON.Vector3(xmin,ymin,zmin);
                let bot2=new BABYLON.Vector3(xmin,ymin,zmax);

                let d1=BABYLON.Vector3.Distance(bot1,ca_p);
                let d2=BABYLON.Vector3.Distance(bot2,ca_p);
                if(d1>d2)
                {
                    let p1=new BABYLON.Vector3(xmin,ymin,zmax);
                    let p2=new BABYLON.Vector3(xmax,ymin,zmax);
        
                    let p3=new BABYLON.Vector3(xmax,ymax,zmax);
                    let p4=new BABYLON.Vector3(xmin,ymax,zmax);

                    let new_v1=this.transform_point(p1,obj);

                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
                else
                {
                    let p1=new BABYLON.Vector3(xmin,ymin,zmin);
                    let p2=new BABYLON.Vector3(xmax,ymin,zmin);
        
                    let p3=new BABYLON.Vector3(xmax,ymax,zmin);
                    let p4=new BABYLON.Vector3(xmin,ymax,zmin);

                    let new_v1=this.transform_point(p1,obj);

                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
            }
            else
            {
                let bot1=new BABYLON.Vector3(xmin,ymin,zmin);
                let bot2=new BABYLON.Vector3(xmax,ymin,zmin);

                let d1=BABYLON.Vector3.Distance(bot1,ca_p);
                let d2=BABYLON.Vector3.Distance(bot2,ca_p);
                if(d1>d2)
                {
                    let p1=new BABYLON.Vector3(xmax,ymin,zmin);
                    let p2=new BABYLON.Vector3(xmax,ymin,zmax);
        
                    let p3=new BABYLON.Vector3(xmax,ymax,zmax);
                    let p4=new BABYLON.Vector3(xmax,ymax,zmin);
    
                    let new_v1=this.transform_point(p1,obj);
    
                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
                else
                {
                    let p1=new BABYLON.Vector3(xmin,ymin,zmin);
                    let p2=new BABYLON.Vector3(xmin,ymin,zmax);
        
                    let p3=new BABYLON.Vector3(xmin,ymax,zmax);
                    let p4=new BABYLON.Vector3(xmin,ymax,zmin);
    
                    let new_v1=this.transform_point(p1,obj);
    
                    ar.push(new_v1);
                    let new_v2=this.transform_point(p2,obj);
    
                    ar.push(new_v2);
                    let new_v3=this.transform_point(p3,obj);
    
                    ar.push(new_v3);
                    let new_v4=this.transform_point(p4,obj);
    
                    ar.push(new_v4);
                    return ar;
                }
            }

        }
        return ar;
    }


}